export const businessCategoryEnum = {
    SOLE_PROPRIETOR: 'SOLE_PROPRIETOR',
    PRIVATE_LIMITED_LIABILITY_COMPANY: 'PRIVATE_LIMITED_LIABILITY_COMPANY',
    PUBLIC_LIMITED_LIABILITY_COMPANY: 'PUBLIC_LIMITED_LIABILITY_COMPANY',
    NON_GOVERNMENTAL_ORGANIZATION: 'NON_GOVERNMENTAL_ORGANIZATION',
    GOVERNMENT: 'GOVERNMENT',
  };
  